import { groupBy } from 'lodash'
import { Receipt } from '../../../domain/receipt'
import { ChangeSet, ServerState, getUpdatedItem } from '../itemModel'
import { ActualItem, isActualItem } from '../../../domain/workareaItem'
import { countDistinct, sum } from '../../../helpers/array'

export type ReceiptView = {
  id: number
  date?: string
  vendor: string
  receiptNumber: string
  items: number
  workareas: number
  enteredBy: string
  total: number
  isDeleted: boolean
  key: number
}

export type AngularReceipt = Receipt & { removed?: boolean, receiptDate?: string }

export const createReceiptViews = (receipts: AngularReceipt[], serverState: ServerState, changeSet: ChangeSet): ReceiptView[] => {
  const allItems = serverState.workareaItems
    .concat(changeSet.addedItems)
    .map(x => getUpdatedItem(x, changeSet))
    .filter(x => isActualItem(x.item) && x.item.receiptId !== undefined && !x.isDeleted)
    .map(x => x.item as ActualItem)
  
  const groupedItems = groupBy(allItems, x => x.receiptId)
  return receipts.map((r, index) => {
    const items = groupedItems[r.id] ?? []
    return {
      id: r.id,
      date: r.receiptDateUtc ?? r.receiptDate,
      vendor: r.vendorName,
      receiptNumber: r.receiptNumber,
      items: items.length,
      workareas: countDistinct(items.map(x => x.workareaId)),
      enteredBy: r.owner,
      total: sum(items, x => (x.cost + x.tax) * x.quantity),
      isDeleted: r.removed === true,
      key: index
    }
  })
}